module.exports = {
    theme: {
        extend: {
            colors: {
                primary: 'rgb(var(--color-primary-rgb) / <alpha-value>)',
                'primary-inverse': 'rgb(var(--color-primary-inverse-rgb) / <alpha-value>)',
                secondary: 'rgb(var(--color-secondary-rgb) / <alpha-value>)',
                'secondary-inverse': 'rgb(var(--color-secondary-inverse-rgb) / <alpha-value>)',
                tertiary: 'rgb(var(--color-tertiary-rgb) / <alpha-value>)',
                'tertiary-inverse': 'rgb(var(--color-tertiary-inverse-rgb) / <alpha-value>)',
                paletteOrange: '#EF7D14',
                paletteGreen: '#00A26C',
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
            lexend: ['Lexend', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
